// extracted by mini-css-extract-plugin
export default {"title":"List_title__HA5lm","item":"List_item__JXpNv","link":"List_link__eYCAJ","amount":"List_amount__gJ76v"};